import React from "react";
import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { AiHighlight } from "./components/landing/AiHighlight";
import { Features } from "./components/landing/Features";
import { Showcase } from "./components/landing/Showcase";
import { HowItWorks } from "./components/landing/HowItWorks";
import { Testimonials } from "./components/landing/Testimonials";
import { Pricing } from "./components/landing/Pricing";
import { Faq } from "./components/landing/Faq";
import { FooterCta } from "./components/landing/FooterCta";

const LandingPage = () => (
  <main className="font-body bg-brutal-cream text-brutal-black">
    <Header />
    <Hero />
    <AiHighlight />
    <Features />
    <Showcase />
    <HowItWorks />
    <Testimonials />
    <Pricing />
    <Faq />
    <FooterCta />
  </main>
);

export default LandingPage;
